import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import { useMount } from '@provider-portal/common/hooks/useMount';

import {
  credentialsAuthAsync,
  logoutAsync,
  NetworkRequestState,
  selectAuthRequestState,
  selectIsUserLoggedIn,
} from '@bolteu/redux-session';

import { selectLogoutRequestState } from 'rdx/session/selectors';

import { LoginUrlParams } from 'screens/Login/Login';

export const LoginWithToken: React.FC = () => {
  const history = useHistory();

  const isUserLoggedIn = useSelector(selectIsUserLoggedIn);
  const authRequestState = useSelector(selectAuthRequestState);
  const logoutRequestState = useSelector(selectLogoutRequestState);
  const dispatch = useDispatch();
  const { token } = useParams<LoginUrlParams>();

  useMount(() => {
    if (authRequestState === NetworkRequestState.unset) {
      if (isUserLoggedIn) {
        dispatch(logoutAsync.request({ shouldResetToken: true }));
      }

      if (!isUserLoggedIn && logoutRequestState === NetworkRequestState.unset) {
        dispatch(credentialsAuthAsync.request({ token } as any));
      }
    }
  });
  useEffect(() => {
    if (logoutRequestState === NetworkRequestState.success) {
      dispatch(credentialsAuthAsync.request({ token } as any));
    }
  }, [dispatch, logoutRequestState, token]);

  useEffect(() => {
    if (
      authRequestState === NetworkRequestState.success ||
      authRequestState === NetworkRequestState.failure
    ) {
      history.push('/');
    }
  });

  return null;
};
